export const NOTIFICATIONS_LOADED = 'NOTIFICATIONS_LOADED';

export const notificationsLoaded = ( notifications ) => ( {
    type:  NOTIFICATIONS_LOADED,
    notifications
} );